import { render, staticRenderFns } from "./RelatorioPedidos.vue?vue&type=template&id=1fe9b7e4&scoped=true&"
import script from "./RelatorioPedidos.vue?vue&type=script&lang=js&"
export * from "./RelatorioPedidos.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioPedidos.vue?vue&type=style&index=0&id=1fe9b7e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe9b7e4",
  null
  
)

export default component.exports